module.exports = __webpack_public_path__ + "static/img/ranqi2.72ea8e0c.png";